import { useMemo } from "react";
import { Container, Navbar, Spinner } from "react-bootstrap";
import { createPortalApi } from "./api/portalApi";
import { useAuth } from "./auth/AuthContext";
import { portalIcon } from "./lib/appIcons";
import VersionStamp from "./components/VersionStamp";
import GuidePage from "./pages/GuidePage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";

export default function App() {
  const { ready, me, mode, logout, getToken } = useAuth();
  const api = useMemo(() => createPortalApi(getToken), [getToken]);

  // The guide is anonymous and static — render it before waiting on auth
  // init so the link in access-granted emails works for brand-new users.
  if (window.location.pathname === "/guide") {
    return (
      <>
        <GuidePage />
        <VersionStamp />
      </>
    );
  }

  if (!ready) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (mode === "none" || !me) {
    return (
      <>
        <LoginPage />
        <VersionStamp />
      </>
    );
  }

  return (
    <>
      <Navbar bg="dark" data-bs-theme="dark" expand="sm" className="mb-4">
        <Container>
          <Navbar.Brand className="d-flex align-items-center">
            <img
              src={portalIcon}
              alt=""
              width={28}
              height={28}
              className="me-2 rounded-1 bg-white"
            />
            TTS Engineering Portal
          </Navbar.Brand>
          <Navbar.Text className="ms-auto me-3">
            <a href="/guide" className="link-light link-underline-opacity-0 link-underline-opacity-75-hover">
              User guide
            </a>
          </Navbar.Text>
          <Navbar.Text className="me-3">{me.displayName || me.email}</Navbar.Text>
          <button className="btn btn-outline-light btn-sm" onClick={() => void logout()}>
            Sign out
          </button>
        </Container>
      </Navbar>
      <HomePage api={api} />
      <VersionStamp />
    </>
  );
}
